import React, { useState, useEffect, useMemo } from "react";
// 🎯 FIXED PATH: Reaching the view in the sibling folder
import TemplateInventoryView from "../views/TemplateInventoryView";
// 🎯 FIXED PATH: Reaching the handshake utility in the parent folder
import { executeWorkflowHandshake } from "../Workflow_XLS_Support";

export default function TemplateInventoryController({ onConfirm }) {
  const [inventory, setInventory] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    const fetchCleanInventory = async () => {
      setLoading(true);
      try {
        // 🎯 FIX: Restoring the full required payload to avoid 400 Bad Request
        const payload = {
          action: "GET_INVENTORY",
          user_id: sessionStorage.getItem("SEC_USER_GUID") || "cdbd2330-c2ef-46d4-8dc9-c34471b0475d",
          payload: {
            bucket: "esg-staging-clean",
            prefix: ""
          },
          siteUserGuid: sessionStorage.getItem("SEC_USER_GUID") || "cdbd2330-c2ef-46d4-8dc9-c34471b0475d",
          sessionID: sessionStorage.getItem("SEC_SESSION_ID") || "b3bae30f-7f81-4437-88a8-4178ca232815"
        };

        const response = await executeWorkflowHandshake(
          "doorman/inventory",
          payload,
          "Inventory"
        );

        // 🎯 Extraction path to match your Inventory Service
        const container = response?.Data || response?.data || response;
        const fileList = container?.files || [];
        
        console.log("📋 [TEMPLATE_INVENTORY_SYNC]:", fileList);
        setInventory(fileList);
      } catch (err) {
        console.error("🚨 [TEMPLATE_INVENTORY_ERROR]:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCleanInventory();
  }, []);

  const auditResults = useMemo(() => {
    const filtered = inventory.filter(f =>
      (f.filename || "").toLowerCase().includes(searchQuery.toLowerCase())
    );
    return {
      paginatedRows: filtered.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage),
      totalRows: filtered.length,
      totalPages: Math.ceil(filtered.length / rowsPerPage) || 1
    };
  }, [inventory, searchQuery, currentPage]);

  return (
    <TemplateInventoryView
      loading={loading}
      results={auditResults}
      selectedFile={selectedFile}
      searchQuery={searchQuery}
      currentPage={currentPage}
      onSearch={(val) => { setSearchQuery(val); setCurrentPage(1); }}
      onPageChange={setCurrentPage}
      onSelect={setSelectedFile}
      onConfirm={() => onConfirm(selectedFile)}
    />
  );
}